export default (heat) => {
  return heat && heat.startList && heat.startList[0] && heat.startList[0].length;
};
